module.exports = __webpack_public_path__ + "img/patient_reg_guide.0d66ca4c.png";